// src/modules/Main/Main.routes.js
import React, { lazy } from "react";
const MainPage = lazy(() => import("./pages/MainPage"));
const PatientInfoPage = lazy(() => import("./pages/PatientInfoPage"));
export const mainRoutes = [
  {
    path: "/Main",
    element: <MainPage />,
  },
  {
    path: "/patient-info/:cipId",
    element: <PatientInfoPage />,
  },
];
